import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GeolocationService} from "../../lib/services/geolocation/geolocation.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'app-activate-location',
    templateUrl: './activate-location.component.html',
    styleUrls: ['./activate-location.component.scss']
})
export class ActivateLocationComponent implements OnInit {


    browsers: any = [
        {
            name: 'Safari',
            url: 'https://support.apple.com/guide/safari/ibrw1074/mac',
            icon: 'assets/icons/safari.png'
        },
        {
            name: 'Firefox',
            url: 'https://support.mozilla.org/es/kb/firefox-comparte-mi-ubicacion-con-sitios-web',
            icon: 'assets/icons/firefox.png'
        },
        {
            name: 'Edge',
            url: 'https://support.microsoft.com/es-es/microsoft-edge/ubicaci%C3%B3n-y-privacidad-en-microsoft-edge-31b5d154-0b1b-90ef-e389-7c7d4ffe7b04',
            icon: 'assets/icons/edge.png'
        },
        {
            name: 'Chrome',
            url: 'https://support.google.com/chrome/answer/142065?hl=es-419&co=GENIE.Platform%3DDesktop',
            icon: 'assets/icons/chrome.png'
        }
    ];
    showErrorMessage = true
    redirectUrl;
    loading = false;

    @Input() isModal = false;
    @Output() closeModalEvent = new EventEmitter()

    constructor(public geolocationService: GeolocationService,
                private router: Router,
                private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
        this.loading = false;
        this.showErrorMessage = true
        this.activatedRoute.queryParams.subscribe(params => {
            this.redirectUrl = params['urlRedirect'];
        })
    }

    open(browser) {
        window.open(browser.url, '_blank')
    }

    async requestLocation() {
        this.showErrorMessage = false;
        this.loading = true;
        try {
            await this.geolocationService.checkLocationPermission();
            this.geolocationService.hasGeolocationPermission = true
            await this.handleSuccessfulPermission();
        } catch (error) {
            this.handleError(error);
        } finally {
            this.loading = false;
        }
    }

    private async handleSuccessfulPermission() {
        if (this.isModal) {
            this.closeModalEvent.emit();
        } else {
            await this.router.navigate(['/nueva-banca-digital/dashboard']);
        }
    }


    private handleError(error: any) {
        this.showErrorMessage = true;
        console.error('Error requesting location:', error);
    }
}
